import { Component, ViewEncapsulation } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-document-edit-item-advanced-text-panel',
    templateUrl: './advanced-text-panel.component.html',
    styleUrls: ['./advanced-text-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DocumentEditItemAdvancedTextPanelComponent {
    ObjectTypes = ObjectTypes;
}
